module.exports = __webpack_public_path__ + "img/9.4824af56.jpg";